import { render, staticRenderFns } from "./InsuranceCards.vue?vue&type=template&id=a40dae06&scoped=true&"
import script from "./InsuranceCards.vue?vue&type=script&lang=js&"
export * from "./InsuranceCards.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceCards.vue?vue&type=style&index=0&id=a40dae06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40dae06",
  null
  
)

export default component.exports